const wrapperProps = {
    horizontal: {
        w: 'full',
        maxW: 'full',
        p: 0,
        pos: 'absolute',
    },
    vertical: {
        pr: 0,
        className: 'w-[128px] max-w-[128px] flex flex-col',
        h: 'full',
        maxH: 'full',
        pos: 'absolute',
    },
} as const;

const internalContainerProps = {
    vertical: 'px-1 scroller overflow-y-scroll overflow-x-auto grow',
    horizontal: 'scroller overflow-y-hidden auto overflow-x-scroll',
};

const positonProps = {
    left: { borderRight: 1, pr: 0, top: 0, left: 0 },
    right: { borderLeft: 1, pl: 0, top: 0, right: 0 },
    bottom: { borderTop: 1, pt: 1, left: 0, bottom: 0, right: 0 },
    top: { borderBottom: 1, pt: 1, top: 0, left: 0, right: 0 },
} as const;

const containerProps = {
    horizontal: { minW: 'max', flexDirection: 'row', justifyContent: 'center' },
    vertical: { flexDirection: 'column', justifyContent: 'center' },
} as const;

const orientationMap = {
    bottom: 'horizontal',
    top: 'horizontal',
    left: 'vertical',
    right: 'vertical',
    none: 'vertical',
} as const;

const legendPositionOptions = [
    { label: 'None', value: 'none' },
    { label: 'Top', value: 'top' },
    { label: 'Bottom', value: 'bottom' },
    { label: 'Left', value: 'left' },
    { label: 'Right', value: 'right' },
];

type LegendPosition = keyof typeof orientationMap;
type LegendOrientation = (typeof orientationMap)[keyof typeof orientationMap];

const LEGEND_HTML_ID = 'chart-legend';

export type { LegendOrientation, LegendPosition };
export {
    containerProps,
    internalContainerProps,
    LEGEND_HTML_ID,
    legendPositionOptions,
    orientationMap,
    positonProps,
    wrapperProps,
};
